/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Builtin_WorkflowInputs */

const en_sch_err_builtin_workflow = /** @type {(inputs: Sch_Err_Builtin_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The built-in workflow cannot be archived or deleted.`)
};

const de_sch_err_builtin_workflow = /** @type {(inputs: Sch_Err_Builtin_WorkflowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der integrierte Workflow lässt sich weder archivieren noch löschen.`)
};

/**
* | output |
* | --- |
* | "The built-in workflow cannot be archived or deleted." |
*
* @param {Sch_Err_Builtin_WorkflowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_builtin_workflow = /** @type {((inputs?: Sch_Err_Builtin_WorkflowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Builtin_WorkflowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_builtin_workflow(inputs)
	return en_sch_err_builtin_workflow(inputs)
});